import edgeCommon from '../common';
import apiService from '../apiService';
import slider from './slider';

let strongbox = (function () {

    let addValidations = function() {3
        $("#update-strongbox").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                project_name: "required",
                group_id: "required",
                // keyword: "required"
            },
            errorPlacement: function (error, element) {
                if (element.attr("name") == "keyword") {
                    error.appendTo(element.parent(".tags"));
                } else {
                    error.insertAfter(element);
                }
            },
        });

        
        $("#update-virtualMachine").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                name: { required: true, alphanumeric: true },
                memory_size: { required: true, min: 2, max: ram_setting_size },
                cpu: { required: true, min: 1, max: cpu_setting_size },
                storage_size: "required",
                additional_drive_1: "required",
                additional_drive_2: "required",
                additional_drive_3: "required",
                os_version: { required: true },
                groups_id: "required",
                guest_os: "required",
            },
        });
    }

    let initStrongbox = function () {

         // need to be removed this function
         $("#save-strongbox").click(function () {
            if ($("#update-strongbox").valid()) {
                let formData = $("#update-strongbox").serialize();
                apiService.postRequest(
                    baseUrl + "/admin/strongbox/store",
                    formData
                );
            }
        });

        // need to be removed this function
        $(document).on("click", ".clone-strongbox", function () {
            let id = $(this).data("id");
            Swal.fire({
                title: "Are you sure?",
                text: "You want to clone this strongbox",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Clone it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: baseUrl + "/admin/strongbox/clone/" + id,
                        type: "GET",
                        success: function (response) {
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                    });
                }
            });
        });

        // need to be check this function
        $(document).on("click", ".delete-strongbox", function () {
            let id = $(this).data("id");
            let groupName = $(this).data("grpname");
            Swal.fire({
                title: "Are you sure you want to delete group " + groupName + "?",
                text: "Deleting this Group will delete all VMs contained with it.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: baseUrl + "/admin/group/delete/" + id,
                        type: "GET",
                        success: function (response) {
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                    });
                }
            });
        });

        $(document).on("click", ".delete-vm", function () {
            let id = $(this).data("id");
            let vmName = $(this).data("vmname");
            Swal.fire({
                title: "Are you sure you want to delete " + vmName + " ?",
                text: "Deleting this virtual machine isn`t reversible",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/admin/virtual-machines/delete/" + id,
                        type: "GET",
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                    });
                }
            });
        });

         // need to be removed this function
         $(document).on("click", ".clone-vm-strongbox", function () {
            let id = $(this).data("id");
            Swal.fire({
                title: "Are you sure?",
                text: "You want to clone this virtual machine to this strongbox",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Clone it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: baseUrl + "/admin/virtual-machines/clone/" + id,
                        type: "GET",
                        success: function (response) {
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                }
            });
        });

        // need to be removed this function
        $(document).on("click", ".clone-vm-new-strongbox", function () {
            let id = $(this).data("id");
            Swal.fire({
                title: "Are you sure?",
                text: "You want to clone this virtual machine to new strongbox",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Clone it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: baseUrl + "/admin/virtual-machines/new-sb/clone/" + id,
                        type: "GET",
                        success: function (response) {
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                    });
                }
            });
        });

        //Open Modal pop up
        $(document).on('click', '.edit-vm', function(){
            $('#update-virtualMachine')[0].reset();
            $("#update-virtualMachine").validate().resetForm();
            $("#save-virtualMachine").text("Update VM");
            let id = $(this).data('id');
            let userid = $(this).data('userid');
            let siteid = $(this).data('siteid');
            if(userid != ''){
                $('#update-virtualMachine #user_id').val(userid);
            }
            if(siteid != ''){
                $('#update-virtualMachine #site_id').val(siteid);
            }
            $.ajax({
                url: baseUrl + '/admin/virtual-machines/edit/'+id,
                type: 'GET',
                success:function(response) {
                    if(response.virtualMachine) {
                        $('#virtualMachineModal').modal('toggle');
                        $('#virtual_id').val(response.virtualMachine.id);
                        $('#name').val(response.virtualMachine.name);
                        let html = '<option value="">Select OS</option>';
                        $.each(response.versions, function(i, v) {
                            html += '<option value="'+i+'">'+v+'</option>';
                        });
                        $('#os_version').html(html);
                        $('#os_version').val(response.virtualMachine.os_version);
                        
                        $('#groups_id').val(response.virtualMachine.group_id);

                        $('.vm_name_count').html(response.virtualMachine.name.length);

                        if(response.virtualMachine.os_system != null)
                            $("input[name=guest_os][value=" + response.virtualMachine.os_system + "]").prop('checked', true);
                        
                        let steps = response.steps;
                        let memoryStep = steps['memory'];
                        let cpuStep = steps['cpu'];
                        let storageStep = steps['storage'];
                        let additional1Step = steps['additional1'];
                        let additional2Step = steps['additional2'];
                        let additional3Step = steps['additional3'];

                        $("#memory_size").attr({"max" : ram_setting_size , "min" : 2, "step" : memoryStep, "value" : response.virtualMachine.memory_size});
                        $("#memory_output").prop({"max" : ram_setting_size , "min" : 2, "step" : memoryStep, "value" : response.virtualMachine.memory_size});
                        
                        $("#memory_output").val(response.virtualMachine.memory_size);
                        $('#memory_size').trigger("change");
                        
                        let cpuD = false;
                        
                        if( response.virtualMachine.cpu == 1){
                            $('#single_cpu').prop('checked', true);
                            $("#cpu").attr({"max" : 1 , "min" : 1, "step" : 1, "value" : response.virtualMachine.cpu});
                            $("#cpu_output").prop({"max" : 1 , "min" : 1, "step" : 1, "value" : response.virtualMachine.cpu});
                            cpuD = true;
                        }else{
                            $("#cpu").attr({"max" : cpu_setting_size , "min" : 0, "step" : cpuStep, "value" : response.virtualMachine.cpu});
                            $("#cpu_output").prop({"max" : cpu_setting_size , "min" : 0, "step" : cpuStep, "value" : response.virtualMachine.cpu});
                        }
                        
                        $('#cpu').trigger("change");
                        
                        $(".ram-label").text('2GB-'+ram_setting_size+'GB');
                        $(".cpu-label").text('1-'+cpu_setting_size+'');
                        
                        $("#storage_size").attr({"max" : primary_storage , "min" : 100, "step" : storageStep, "value" : response.virtualMachine.storage_size});
                        $("#storage_output").prop({"max" : primary_storage , "min" : 100, "step" : storageStep, "value" : response.virtualMachine.storage_size});

                        $('#storage_size').trigger("change");

                        if(response.virtualMachine.additional_drive_1 || response.virtualMachine.additional_drive_2 || response.virtualMachine.additional_drive_3) {
                            $('#additional_drive_div').removeClass('d-none');
                        } else {
                            $('#additional_drive_div').addClass('d-none');
                        }

                        let aS1D = true;
                        let additional1Div = additional_storage_1/additional1Step;
                        if(response.virtualMachine.additional_drive_1) {
                            $('#is_additional_drive_1').prop('checked', true);
                            $('#additional_drive_1').prop('disabled', false);
                            
                            $("#additional_drive_1").attr({"max" : additional_storage_1 , "min" : 50, "step" : additional1Step, "value" : response.virtualMachine.additional_drive_1});
                            $("#add_drive_output").prop({"max" : additional_storage_1 , "min" : 50, "step" : additional1Step, "value" : response.virtualMachine.additional_drive_1});
                            
                            $('#additional_drive_1').trigger("change");
                            aS1D = false;
                        } else {
                            $('#is_additional_drive_1').prop('checked', false);
                            $('#additional_drive_1').prop('disabled', true);
                            
                            $("#additional_drive_1").attr({"max" : additional_storage_1 , "min" : 50, "step" : additional1Step, "value" : 50});
                            $("#add_drive_output").prop({"max" : additional_storage_1 , "min" : 50, "step" : additional1Step, "value" : 50});
                                                       
                            $('#additional_drive_1').trigger("change");
                        }

                        let aS2D = true;
                        let additional2Div = additional_storage_2/additional2Step;
                        if(response.virtualMachine.additional_drive_2) {
                            $('#is_additional_drive_2').prop('checked', true);
                            $('#additional_drive_2').prop('disabled', false);
                            
                            $("#additional_drive_2").attr({"max" : additional_storage_2 , "min" : 50, "step" : additional2Step, "value" : response.virtualMachine.additional_drive_2});
                            $("#add_drive_2_output").prop({"max" : additional_storage_2 , "min" : 50, "step" : additional2Step, "value" : response.virtualMachine.additional_drive_2});
                            
                            $('#additional_drive_2').trigger("change");
                            aS2D = false;
                        }else{
                            $('#is_additional_drive_2').prop('checked', false);
                            $('#additional_drive_2').prop('disabled', true);
                            
                            $("#additional_drive_2").attr({"max" : additional_storage_2 , "min" : 50, "step" : additional2Step, "value" : 50});
                            $("#add_drive_2_output").prop({"max" : additional_storage_2 , "min" : 50, "step" : additional2Step, "value" : 50});
                            
                            $('#additional_drive_2').trigger("change");
                        }

                        let aS3D = true;
                        let additional3Div = additional_storage_3/additional3Step;
                        if(response.virtualMachine.additional_drive_3) {
                            $('#is_additional_drive_3').prop('checked', true);
                            $('#additional_drive_3').prop('disabled', false);
                            
                            $("#additional_drive_3").attr({"max" : additional_storage_3 , "min" : 50, "step" : additional3Step, "value" : response.virtualMachine.additional_drive_3});
                            $("#add_drive_3_output").prop({"max" : additional_storage_3 , "min" : 50, "step" : additional3Step, "value" : response.virtualMachine.additional_drive_3});
                            
                            $('#additional_drive_3').trigger("change");
                            aS3D = false;
                        }else{
                            $('#is_additional_drive_3').prop('checked', false);
                            $('#additional_drive_3').prop('disabled', true);
                            
                            $("#additional_drive_3").attr({"max" : additional_storage_3 , "min" : 50, "step" : additional3Step, "value" : 50});
                            $("#add_drive_3_output").prop({"max" : additional_storage_3 , "min" : 50, "step" : additional3Step, "value" : 50});
                            
                            $('#additional_drive_3').trigger("change");
                        }

                        slider.slider("storage_size_div");
                        slider.slider("cpu_div", {'disable': cpuD, });
                        slider.slider("additional_drive_3_div", {'disable': aS3D, });
                        slider.slider("additional_drive_2_div", {'disable': aS2D, });
                        slider.slider("additional_drive_1_div", {'disable': aS1D, });
                        slider.slider("memory_size_div");
                    }
                }
            });
        })

        //Open Modal pop up
        $(document).on('click', '.add-vm-strongbox', function(){
           
            $('#update-virtualMachine')[0].reset();
            $("#update-virtualMachine").validate().resetForm();
            $("input[name=guest_os][value='Windows']").prop('checked', true);
            $("#save-virtualMachine").text("Create VM");

            let id = $(this).data('id');
            let userid = $(this).data('userid');
            let siteid = $(this).data('siteid');
            if(userid != ''){
                $('#update-virtualMachine #user_id').val(userid);
            }
            if(siteid != ''){
                $('#update-virtualMachine #site_id').val(siteid);
            }
            $.ajax({
                url: baseUrl + '/admin/strongbox/get-strongbox/'+id,
                type: 'GET',
                success:function(response) {
                    console.log(response);
                    if(response.group) {
                        $('#virtualMachineModal').modal('toggle');
                        $('#virtual_id').val('');
                        $('#groups_id').val(response.group.id);

                        let html = '<option value="">Select OS</option>';
                        $.each(response.versions, function(i, v) {
                            html += '<option value="'+i+'">'+v+'</option>';
                        });
                        $('#os_version').html(html);

                        let totalCpu = cpu_setting_size - response.totalCpu;
                        if(totalCpu == 0){
                            $('#single_cpu').prop('disabled', true);
                        }else{
                            $('#single_cpu').prop('disabled', false);
                        }
                        $('#single_cpu').trigger("change");

                        let steps = response.steps;
                        let memoryStep = steps['memory'];
                        let cpuStep = steps['cpu'];
                        let storageStep = steps['storage'];
                        let additional1Step = steps['additional1'];
                        let additional2Step = steps['additional2'];
                        let additional3Step = steps['additional3'];
                        
                        $("#memory_size").attr({"max" : ram_setting_size , "min" : 2, "step" : memoryStep, "value" : 2});
                        $("#memory_output").prop({"max" : ram_setting_size , "min" : 2, "step" : memoryStep, "value" : 2});
                       
                        $('#memory_size').trigger("change");
                       
                        $("#cpu").attr({"max" : cpu_setting_size , "min" : 0, "step" : cpuStep, "value" : 2});
                        $("#cpu_output").prop({"max" : cpu_setting_size , "min" : 0, "step" : cpuStep, "value" : 2});
                        
                        $('#cpu').trigger("change");
                        
                        $("#storage_size").attr({"max" : primary_storage , "min" : 100, "step" : storageStep, "value" : 100});
                        $("#storage_output").prop({"max" : primary_storage , "min" : 100, "step" : storageStep, "value" : 100});
                        
                        $('#storage_size').trigger("change");
                        
                        $(".ram-label").text('2GB-'+ram_setting_size+'GB');
                        $(".cpu-label").text('1-'+cpu_setting_size+'');

                        $('#additional_drive_div').addClass('d-none');
                        $('#is_member').prop('checked', false);

                        $('#is_additional_drive_1').prop('checked', false);
                        $('#additional_drive_1').prop('disabled', true);
                        
                        $("#additional_drive_1").attr({"max" : additional_storage_1 , "min" : 50, "step" : additional1Step, "value" : 50});
                        $("#add_drive_output").prop({"max" : additional_storage_1 , "min" : 50, "step" : additional1Step, "value" : 50});
                        
                        $('#additional_drive_1').trigger("change");

                        $('#is_additional_drive_2').prop('checked', false);
                        $('#additional_drive_2').prop('disabled', true);
                        
                        $("#additional_drive_2").attr({"max" : additional_storage_2 , "min" : 50, "step" : additional2Step, "value" : 50});
                        $("#add_drive_2_output").prop({"max" : additional_storage_2 , "min" : 50, "step" : additional2Step, "value" : 50});
                        
                        $('#additional_drive_2').trigger("change");

                        $('#is_additional_drive_3').prop('checked', false);
                        $('#additional_drive_3').prop('disabled', true);
                        
                        $("#additional_drive_3").attr({"max" : additional_storage_3 , "min" : 50, "step" : additional3Step, "value" : 50});
                        $("#add_drive_3_output").prop({"max" : additional_storage_3 , "min" : 50, "step" : additional3Step, "value" : 50});
                        
                        $('#additional_drive_3').trigger("change");

                        $('#os_version').val('');

                        slider.slider("storage_size_div");
                        slider.slider("cpu_div");
                        slider.slider("additional_drive_3_div", {'disable': true, });
                        slider.slider("additional_drive_2_div", {'disable': true, });
                        slider.slider("additional_drive_1_div", {'disable': true, });
                        slider.slider("memory_size_div");
                    }
                }
            })
        });

        $("#save-virtualMachine").on("click", function () {
            if ($("#update-virtualMachine").valid()) {
                let formData = $("#update-virtualMachine").serialize();
                apiService.postRequest(
                    baseUrl + "/admin/virtual-machines/update",
                    formData
                );
            }
        });
    };

    return {
        // public functions
        init: function () {
            addValidations();
            initStrongbox();
        },
    };
})();

$(document).ready(function () {
    strongbox.init();
});
